import { Controller } from 'stimulus';

class ReadMoreController extends Controller {
  connect() {
    this.isCollapsed = this.data.get('is-collapsed') === 'true';
  }

  onToggleClick() {
    this.isCollapsed = !this.isCollapsed;

    const buttonText = this.isCollapsed ? this.data.get('collapsed-text') : this.data.get('expanded-text');
    const buttonIcon = this.isCollapsed ? this.getIcon('arrow-down') : this.getIcon('arrow-up');

    this.element.classList.toggle('is-collapsed', this.isCollapsed);
    this.toggleTarget.innerHTML = `${buttonText} ${buttonIcon}`;
  }

  // eslint-disable-next-line class-methods-use-this
  getIcon(name) {
    return `
      <svg class="icon icon-${name}" aria-hidden="true">
        <use xlink:href="#icon-${name}"></use>
      </svg>
    `;
  }
}

ReadMoreController.targets = [
  'toggle',
];

export default ReadMoreController;
